module.exports = __webpack_public_path__ + "img/9788973379705.5a620b54.jpg";